<template>
  <Loading v-if="isLoading" />
  <div class="narrow_container" v-else>
    <Breadcrumb
      :category="
        category == 'car_rental'
          ? '自駕遊'
          : category == 'code'
          ? '產品編號'
          : categroyName()
      "
      :link="category"
      :code="category == 'car_rental' ? product.productName : code"
    />
    <div class="rows">
      <div class="columns main_column product_detail">
        <div class="detail_title">{{ product.productName }}</div>
        <vueper-slides
          class="no-shadow"
          :arrows-outside="false"
          :bullets="true"
          :dragging-distance="10"
          :infinite="true"
          duration="4000"
          transition-speed="500"
          :breakpoints="breakpoints"
          autoplay
          @autoplay-pause="internalAutoPlaying = false"
          @autoplay-resume="internalAutoPlaying = true"
          v-if="product.media.length > 0"
          style="margin: 20px 0"
        >
          <vueper-slide
            v-for="(item, i) in product.media"
            :key="i"
            :image="item.url"
          />
        </vueper-slides>
        <div v-else style="height: 50px">&nbsp;</div>
        <template v-if="category != 'car_rental'">
          <ul class="main_point">
            <li v-if="product.refundAmendDescription">
              <img :src="require('@/assets/icons/icon_bstg.svg')" />
              {{ product.refundAmendDescription }}
            </li>
            <li v-if="product.redeemMethod">
              <img :src="require('@/assets/icons/icon_hwdh.svg')" />
              {{ product.redeemMethod }}
            </li>
            <li v-if="product.digitalRedeemMethod">
              <img :src="require('@/assets/icons/icon_dzpz.svg')" />
              {{ product.digitalRedeemMethod }}
            </li>
            <li v-if="product.effectiveDate">
              <img :src="require('@/assets/icons/icon_dzpz.svg')" />
              {{ product.effectiveDate }}
            </li>
          </ul>
          <ul
            class="other_point"
            style="padding-top: 150px; margin-top: -150px"
            v-if="product.highlight.length > 0"
          >
            <li v-for="item in product.highlight" :key="item.value">
              {{ item }}
            </li>
          </ul>
          <div class="detail_description">
            {{ product.description }}
          </div>
          <div
            class="detail_part"
            v-if="
              product.itineraryDayOne != '' &&
              product.itineraryDayOne.length > 0
            "
          >
            <h5>行程表</h5>
            <template
              v-if="
                product.itineraryDayOne != '' &&
                product.itineraryDayOne.length > 0
              "
            >
              <h6>第一天</h6>
              <ul style="list-style: disc; margin-left: 20px">
                <li v-for="(item, idx) in product.itineraryDayOne" :key="idx">
                  {{ item }}
                </li>
              </ul>
            </template>
            <template
              v-if="
                product.itineraryDayTwo != '' &&
                product.itineraryDayTwo.length > 0
              "
            >
              <h6>第二天</h6>
              <ul style="list-style: disc; margin-left: 20px">
                <li v-for="(item, idx) in product.itineraryDayTwo" :key="idx">
                  {{ item }}
                </li>
              </ul>
            </template>
            <template
              v-if="
                product.itineraryDayThree != '' &&
                product.itineraryDayThree.length > 0
              "
            >
              <h6>第三天</h6>
              <ul style="list-style: disc; margin-left: 20px">
                <li v-for="(item, idx) in product.itineraryDayThree" :key="idx">
                  {{ item }}
                </li>
              </ul>
            </template>
          </div>
          <div id="bookingAnchor" style="margin-top: 20px"></div>
          
        <template
          v-if="
            inputList.length > 0 &&
            deviceMode == 'desktop'
          "
        >
          <br />
          <h5>資料搜尋</h5>
          <div v-for="(item, idx) in inputList" :key="idx">
            <!--Text-->
            <FreeText
              v-if="item.type.toUpperCase() == 'FREETEXT' && item.showBeforeItem"
              :data="item"
              :mode="mode"
            />
            <!--List-->
            <List
              v-if="
                (item.type.toUpperCase() == 'LIST' ||
                item.type.toUpperCase() == 'RADIOBUTTON') && item.showBeforeItem
              "
              :data="item"
              :mode="mode"
            />
            <!--Date-->
            <DatePicker
              v-if="item.type.toUpperCase() == 'DATE' && item.showBeforeItem "
              :data="item"
              :mode="mode"
            />
          </div>
        </template>
          <ProductOption
            :useDateCompulsory="product.useDateCompulsory"
            :orderList="orderList"
            :inputList="inputList"
            :productCode="code"
            :placeholder="placeholder"
            v-if="deviceMode == 'desktop'"
          />
          <template
          v-if="
            inputList.length > 0 &&
            deviceMode == 'desktop'
          "
        >
          <br />
          <h5 id="additionalAnchor">附加資料</h5>
          <div v-for="(item, idx) in inputList" :key="idx">
            <!--Text-->
            <FreeText
              v-if="item.type.toUpperCase() == 'FREETEXT' && !item.showBeforeItem"
              :data="item"
              :mode="mode"
            />
            <!--List-->
            <List
              v-if="
                (item.type.toUpperCase() == 'LIST' ||
                item.type.toUpperCase() == 'RADIOBUTTON') && !item.showBeforeItem
              "
              :data="item"
              :mode="mode"
            />
            <!--Date-->
            <DatePicker
              v-if="item.type.toUpperCase() == 'DATE' && !item.showBeforeItem "
              :data="item"
              :mode="mode"
            />
          </div>
          </template>
        </template>
        <template v-if="category == 'car_rental'">
          <div class="detail_part">
            <h5>產品簡介</h5>
            <ul class="other_point" style="padding-left: 25px">
              <li>租車公司：{{ product.carInfo.supplierName }}</li>
              <li>自駕遊收費計劃：{{ product.price.rateTypeDescription }}</li>
              <li>型號：{{ product.carInfo.modelName }}</li>
              <li>規格：{{ product.carInfo.engineSpec }}</li>
              <li>
                行李數量：{{
                  product.carInfo.noOfBaggages != undefined &&
                  product.carInfo.noOfBaggages != null &&
                  product.carInfo.noOfBaggages.trim() != ""
                    ? product.carInfo.noOfBaggages
                    : "沒有資料"
                }}
              </li>
              <li>車門數量：{{ product.carInfo.noOfDoors }}</li>
              <li>乘客數量：{{ product.carInfo.noOfPassengers }}</li>
            </ul>
          </div>
          <div
            class="detail_part"
            id="bookingAnchor"
            v-if="deviceMode == 'desktop'"
          >
            <h5>租車選項</h5>
            <div class="collectInfo">
              <div class="item_select">
                <CarRentalOption
                  :pickupBranchList="product.pickupBranch"
                  :returnBranchList="product.returnBranch"
                  :carOptionList="product.carOption"
                  mode="input"
                />
              </div>
            </div>
          </div>
          <div class="detail_part">
            <h5>注意事項</h5>
            <ul class="detail_reminder">
              <li
                v-for="item in product.remark"
                :key="item.value"
                style="list-style: none"
                v-html="item"
              ></li>
            </ul>
          </div>
          <div id="recommendation">&nbsp;</div>
        </template>
        <template v-else>
          <div class="detail_part">
            <template
              v-if="product.feeInclude.length > 0 && product.feeInclude != ''"
            >
              <h5>費用包括</h5>
              <div class="table">
                <div
                  class="table_row"
                  v-for="item in product.feeInclude"
                  :key="item"
                >
                  <div class="table_cell narrow">
                    <i class="far fa-check-circle"></i>
                  </div>
                  <div class="table_cell">{{ item }}</div>
                </div>
              </div>
            </template>
            <template
              v-if="product.feeExclude.length > 0 && product.feeExclude != ''"
            >
              <h5>費用不包括</h5>
              <div class="table">
                <div
                  class="table_row"
                  v-for="item in product.feeExclude"
                  :key="item"
                >
                  <div class="table_cell narrow">
                    <i class="far fa-times-circle"></i>
                  </div>
                  <div class="table_cell">{{ item }}</div>
                </div>
              </div>
            </template>
            <template
              v-if="
                product.eventTransportation.length > 0 &&
                product.eventTransportation[0] != ''
              "
            >
              <h5>前往方法</h5>
              <ul class="fee_point">
                <li
                  v-for="item in product.eventTransportation"
                  :key="item.value"
                >
                  {{ item }}
                </li>
              </ul>
            </template>
            <template v-if="product.openingHour.length > 0">
              <h5>開放時間</h5>
              <ul class="fee_point">
                <li v-for="item in product.openingHour" :key="item.value">
                  {{ item }}
                </li>
              </ul>
            </template>
            <template
              v-if="
                product.eventLocation.length > 0 &&
                product.eventLocation[0].address != undefined
              "
            >
              <h5>活動地點</h5>
              <ul class="fee_point">
                <li v-for="(item, idx) in product.eventLocation" :key="idx">
                  {{ item.address }}
                </li>
              </ul>
            </template>
            <template
              v-if="
                product.eventLocation.length > 0 &&
                product.eventLocation[0].longitude != undefined &&
                product.eventLocation[0].latitude != undefined
              "
            >
              <GoogleMap
                api-key="AIzaSyAifLAtkNHk1mQWHu4jIIDxdIQfdIw6Ec8"
                :style="
                  deviceMode == 'desktop'
                    ? 'width: 100%; height: 360px'
                    : 'width: 100%; height: 280px'
                "
                :center="{
                  lat: product.eventLocation[0].latitude,
                  lng: product.eventLocation[0].longitude,
                }"
                :zoom="12"
              >
                <Marker
                  :options="{
                    position: {
                      lat: product.eventLocation[0].latitude,
                      lng: product.eventLocation[0].longitude,
                    },
                  }"
                />
              </GoogleMap>
              <br />
            </template>
            <template
              v-if="
                product.gatherTime.length > 0 &&
                product.gatherTime[0].trim() != ''
              "
            >
              <h5>集合時間</h5>
              <ul class="fee_point">
                <li v-for="item in product.gatherTime" :key="item.value">
                  {{ item }}
                </li>
              </ul>
            </template>
            <template
              v-if="
                product.gatherLocation.length > 0 &&
                product.gatherLocation[0].trim() != ''
              "
            >
              <h5>集合地點</h5>
              <ul class="fee_point">
                <li v-for="(item, idx) in product.gatherLocation" :key="idx">
                  <span>{{ item }}</span>
                </li>
              </ul>
            </template>
            <template
              v-if="
                product.gatherMapUrl.length > 0 &&
                product.gatherMapUrl[0].title.trim() != ''
              "
            >
              <div
                v-for="(item, idx) in product.gatherMapUrl"
                :key="idx"
                style="margin-bottom: 30px"
              >
                <h6>{{ item.title }}</h6>
                <template v-if="item.url != null">
                  <img :src="item.url" />
                </template>
              </div>
            </template>
            <template
              v-if="
                product.refundAmendDescription != undefined &&
                product.refundAmendDescription != ''
              "
            >
              <h5>退改條款</h5>
              <ul class="fee_point">
                <li>{{ product.refundAmendDescription }}</li>
              </ul>
              <ul
                class="fee_point"
                v-if="
                  product.refundAmendDetail != undefined &&
                  product.refundAmendDetail != ''
                "
              >
                <li
                  v-for="item in product.refundAmendDetail"
                  :key="item"
                  style="list-style: disc; margin-left: 20px"
                >
                  {{ item }}
                </li>
              </ul>
            </template>
            <template v-if="product.website.length > 0">
              <h5>有用網址</h5>
              <ul class="fee_point">
                <li v-for="item in product.website" :key="item.value">
                  <a
                    :href="item.url"
                    target="_blank"
                    v-if="item.caption != ''"
                    style="text-decoration: underline; color: #036eb8"
                    >{{ item.caption }}</a
                  >
                  <a
                    :href="item.url"
                    target="_blank"
                    style="text-decoration: underline; color: #036eb8"
                    v-else
                    >{{ item.url }}</a
                  >
                </li>
              </ul>
            </template>
            <template
              v-if="
                category != 'car_rental' && product.redeemWebsite.length > 0
              "
            >
              <h5>兌換點網址</h5>
              <ul class="fee_point">
                <li v-for="item in product.redeemWebsite" :key="item.value">
                  <a
                    :href="item.url"
                    target="_blank"
                    style="text-decoration: underline; color: #036eb8"
                    >{{ item.caption }}</a
                  >
                </li>
              </ul>
            </template>
            <template
              v-if="
                category != 'car_rental' && product.redeemLocationMap.length > 0
              "
            >
              <h5>兌換點地址</h5>
              <ul class="fee_point">
                <li v-for="(item, idx) in product.redeemLocationMap" :key="idx">
                  <p
                    v-if="
                      product.redeemLocationMap[idx].address != null &&
                      product.redeemLocationMap[idx].address != ''
                    "
                  >
                    {{ product.redeemLocationMap[idx].address }}
                  </p>
                </li>
              </ul>
            </template>
          </div>
        </template>
        <template
          v-if="category != 'car_rental' && product.reminder.length > 0"
        >
          <h5>注意事項</h5>
          <ul class="detail_reminder">
            <li
              v-for="item in product.reminder"
              :key="item.id"
              v-html="item"
            ></li>
          </ul>
        </template>
      </div>
      <div class="columns shoulder_column" style="position: relative">
        <CarRentalBooking
          class="detail_summary"
          v-if="category == 'car_rental'"
          :product="product"
          :pickupBranch="pickupBranch"
          :returnBranch="returnBranch"
          :carOptions="carOptions"
        />
        <TktProductBooking
          :product="product"
          :orderList="orderList"
          :placeholder="placeholder"
          class="detail_summary"
          id="detail_summary"
          v-else
        />
      </div>
    </div>
    <br />
    <template v-if="category != 'car_rental'">
      <div class="sub_title_divider"></div>
      <div class="sub_title" id="recommendation">更多推介行程</div>
      <ProductCarousel
        productKey="LOCATION"
        :productValue="product.productLocation[0]"
      />
    </template>
    <div class="detail_btn_group mobile" v-if="deviceMode != 'desktop'">
      <button
        type="button"
        class="btn"
        style="width: 100%"
        @click.stop="openBottomOverlay()"
      >
        立即購買
      </button>
    </div>
    <div
      class="bottom_overlay"
      id="product_option_overlay"
      v-if="deviceMode != 'desktop'"
    >
      <div class="close_handler" @click.stop="closeBottomOverlay()">&nbsp;</div>
      <div class="bottom_overlay_content">
        <template v-if="category == 'car_rental'">
          <CarRentalOption
            :pickupBranchList="product.pickupBranch"
            :returnBranchList="product.returnBranch"
            :carOptionList="product.carOption"
            mode="input"
          />
        </template>
        <template v-else>          
          <template v-if="inputList.length > 0">
            <br />
            <h5>資料搜尋</h5>
            <div v-for="(item, idx) in inputList" :key="idx">
              <!--Text-->
              <FreeText
                v-if="item.type.toUpperCase() == 'FREETEXT' && item.showBeforeItem"
                :data="item"
                :mode="mode"
              />
              <!--List-->
              <List
                v-if="
                  (item.type.toUpperCase() == 'LIST' ||
                  item.type.toUpperCase() == 'RADIOBUTTON' ) && item.showBeforeItem
                "
                :data="item"
                :mode="mode"
              />
              <!--Date-->
              <DatePicker
                v-if="item.type.toUpperCase() == 'DATE'  && item.showBeforeItem"
                :data="item"
                :mode="mode"
              />
              </div>
              <ProductOption
            :useDateCompulsory="product.useDateCompulsory"
            :orderList="orderList"
            :productCode="code"
            :placeholder="placeholder"
            :inputList="inputList"             
          />
          <br />
            <h5 id="additionalAnchor">附加資料</h5>
            <div v-for="(item, idx) in inputList" :key="idx">
              <!--Text-->
              <FreeText
                v-if="item.type.toUpperCase() == 'FREETEXT' && !item.showBeforeItem"
                :data="item"
                :mode="mode"
              />
              <!--List-->
              <List
                v-if="
                  (item.type.toUpperCase() == 'LIST' ||
                  item.type.toUpperCase() == 'RADIOBUTTON' ) && !item.showBeforeItem
                "
                :data="item"
                :mode="mode"
              />
              <!--Date-->
              <DatePicker
                v-if="item.type.toUpperCase() == 'DATE'  && !item.showBeforeItem"
                :data="item"
                :mode="mode"
              />
              </div>
          </template>
          <template v-else>
          <ProductOption
            :useDateCompulsory="product.useDateCompulsory"
            :orderList="orderList"
            :productCode="code"
            :placeholder="placeholder"
            :inputList="inputList"
          />
          </template>
        </template>
        <table
          class="table"
          style="margin: 20px 0; padding-bottom: 180px; border: 1px solid #fff"
        >
          <tbody>
            <tr>
              <td style="text-align: left; vertical-align: middle">
                總額：HKD{{ totalAmount }}
              </td>
              <td style="text-align: right; vertical-align: middle">
                <template v-if="category == 'car_rental'">
                  <button
                    type="button"
                    class="btn btn-primary"
                    style="background: #19b0c1"
                    @click.stop="addCarRentalToCart(false)"
                  >
                    加入購物車
                  </button>
                </template>
                <template v-else>
                  <button
                    type="button"
                    class="btn btn-primary"
                    style="background: #19b0c1"
                    @click.stop="addTktProductToCart(false)"
                  >
                    加入購物車
                  </button>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref,
  computed,
  nextTick,
  onBeforeMount,
  onMounted,
  onBeforeUnmount,
  inject,
} from "vue";
import ApiService from "@/services/ApiService.js";
import CartApiService from "@/services/CartApiService.js";
import _ from "lodash";
import moment from "moment";
import { useStore } from "vuex";
import useEventBus from "@/config/eventBus";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import List from "@/widgets/List.vue";
import FreeText from "@/widgets/FreeText.vue";
import DatePicker from "@/widgets/DatePicker.vue";
import TktProductBooking from "@/components/TktProductBooking.vue";
import CarRentalBooking from "@/components/CarRentalBooking.vue";
import ProductCarousel from "@/components/ProductCarousel.vue";
import CarRentalOption from "@/components/CarRentalOption.vue";
import ProductOption from "@/components/ProductOption.vue";
import router from "@/router";
import { GoogleMap, Marker } from "vue3-google-map";

export default {
  props: {
    category: {
      type: String,
      required: true,
    },
    code: {
      type: String,
      required: true,
    },
  },
  components: {
    VueperSlides,
    VueperSlide,
    List,
    FreeText,
    DatePicker,
    TktProductBooking,
    ProductCarousel,
    CarRentalBooking,
    CarRentalOption,
    ProductOption,
    GoogleMap,
    Marker,
  },
  data: () => ({
    breakpoints: {
      768: {
        slideRatio: 1 / 1.75,
        visibleSlides: 1,
      },
      1024: {
        slideRatio: 1 / 2.2,
        visibleSlides: 1,
      },
      2000: {
        slideRatio: 1 / 1.66,
        visibleSlides: 1,
      },
    },
    mode: "write",
  }),
  setup(props) {
    const isLoading = ref(true);
    const product = ref({});
    const inputList = ref([]);
    const msg = ref("");
    const placeholder = "輸入使用日期";
    const store = useStore();
    const eventBus = useEventBus();
    const orderList = ref([]);
    const splitCode = ref([]);
    const pickupBranchId = ref(0);
    const returnBranchId = ref(0);
    const pickupBranch = ref("未選擇");
    const returnBranch = ref("未選擇");
    const carOptions = ref([]);
    const carRentalOptionIds = ref([]);
    const isAllowedToAdd = ref(false);
    const carId = ref(0);
    const rateType = ref("");
    const carRentalItems = ref([]);
    const days = ref(0);
    const checkInputValid = inject("checkInputValid");
    const deviceMode = computed(() => store.getters["device/mode"]);
    const cartItem = computed(() => store.getters["cart/items"]);
    const member = computed(() => store.getters["member/info"]);
    const categories = computed(() => store.getters["category/categories"]);
    const carRentalForm = computed(() => store.getters["carRental/form"]);

    const totalAmount = computed(() => {
      let total = 0;
      if (props.category == "car_rental") {
        let extraFee = 0;
        if (carOptions.value.length > 0) {
          carOptions.value.forEach((item) => {
            if (item.price != null && parseInt(item.price) > 0) {
              let price = item.price * (days.value + 1);
              extraFee += parseInt(price);
            }
          });
        }
        total =
          extraFee +
          product.value.price.sellingPrice +
          product.value.price.nocCharge +
          product.value.price.crossRegionCharge;
      } else {
        orderList.value.forEach(function (item) {
          if (item.date != placeholder) {
              console.log(inputList);
            total += item.price * item.qty;
          }
        });
      }
      return total;
    });

    const handleNextTick = async () => {
      await nextTick();

      const summaryHeight =
        props.category == "car_rental"
          ? 0
          : $("#detail_summary")[0].offsetHeight;
      const offsetBottom = $("#recommendation")[0].offsetTop;

      days.value = moment(product.value.returnDate).diff(
        moment(product.value.pickupDate),
        "days"
      );

      $(window).on("scroll", function () {
        if ($(window).scrollTop() + summaryHeight - offsetBottom > -188) {
          $("#detail_summary").css({
            top: "-500px",
          });
        } else {
          $("#detail_summary").css({
            top: "158px",
          });
        }
      });
    };

    const categroyName = () => {
      let value = "";
      for (let i = 0; i < categories.value.length; i++) {
        if (categories.value[i].link == props.category) {
          value = categories.value[i].title;
          break;
        } else {
          for (let j = 0; j < categories.value[i].submenu.length; j++) {
            if (categories.value[i].submenu[j].link == props.category) {
              value = categories.value[i].submenu[j].title;
              break;
            }
          }
        }
      }
      return value;
    };

    const search = (scope, keyword) => {
      let link = null;
      if (scope == "product") {
        for (let i = 0; i < categories.value.length; i++) {
          if (categories.value[i].title == keyword) {
            link = categories.value[i].link;
            break;
          } else {
            for (let j = 0; j < categories.value[i].submenu.length; j++) {
              if (categories.value[i].submenu[j].title == keyword) {
                link = categories.value[i].submenu[j].link;
                break;
              }
            }
          }
        }
        if (link != null) router.push("/product/" + link);
        else router.push("/search/product_name/" + keyword);
      } else router.push("/search/" + scope + "/" + keyword);
    };

    const openBottomOverlay = () => {
      $("#product_option_overlay").stop().slideDown(500);
      $(".back_to_top").hide();
      $("html").css({
        overflowY: "hidden",
      });
    };
    
    const closeBottomOverlay = () => {
      $("#product_option_overlay").stop().slideUp(300);
      $(".back_to_top").show();
      $("html").css({
        overflowY: "auto",
      });
    };

    const addTktProductToCart = async (_proceed) => {
      const orderListClone = _.cloneDeep(orderList.value);
      let ticketItems = [];
      orderListClone.forEach(function (element) {
        if (element.date != placeholder && element.qty > 0) {
          element.price = Number(element.price);
          ticketItems.push({
            productItemId: element.itemId == 0 ? element.id : element.itemId,
            qty: element.qty,
            useDate: element.date,
          });
        }
      });
      if (ticketItems.length > 0) {
        if (inputList.value.length == 0) {
          isAllowedToAdd.value = true;
        } else {
            console.log("before checkValid");
            console.log(ticketItems);
          eventBus.emit("checkValid",ticketItems);
          const isAllValid = await checkInputValid(inputList.value);
          console.log("isAllValid:"+isAllValid);
          if (isAllValid) {
            isAllowedToAdd.value = true;
          } else {
            const anchor = document.getElementById("additionalAnchor");
            setTimeout(() => {
              anchor.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }, 50);
            eventBus.emit("showToast", {
              msg: "請完成附加資料！",
              warning: true,
            });
          }
        }
        if (isAllowedToAdd.value) {
          eventBus.emit("showToast", {
            msg: "請稍候，系統處理中...！",
            warning: false,
          });

          if (cartItem.value.cartId == 0) {
            const res = await CartApiService.getCartId(member.value.memberId);
            if (res.cartId != undefined && res.token != undefined) {
              await store.dispatch("cart/updateItem", {
                cartId: res.cartId,
                token: res.token,
              });
            }
          }
          let infoInputs = [];
          if (inputList.value.length > 0) {
            infoInputs = inputList.value.map(({ id, ...item }) => item);
          }
          for(let i =0;i<infoInputs.length;i++){
            delete infoInputs[i]['infoInputOptions_'];
          }
          const params = {
            proceed: _proceed,
            ticketItems: ticketItems,
            infoInputs: infoInputs,
          };
          CartApiService.addItemToCart(
            cartItem.value.cartId,
            cartItem.value.token,
            params
          ).then((res) => {
            console.log(res);
            if (res.state != undefined && res.state == "SUCCESS") {
              CartApiService.getItemCount(cartItem.value.cartId).then((res) => {
                console.log(res);
                if (res.itemCount != undefined) {
                  store.dispatch("cart/updateItem", {
                    counts: res.itemCount,
                  });
                  //reset productOption / apiList selected value.
                  eventBus.emit("resetSelectedValue", null);
                  /*orderList.value.forEach(function (element) {
                    element.date = placeholder;
                    element.qty = 0;
                  });
                  $("input[type=number]").val(0);*/
                  eventBus.emit("hasAddedToCart");
                  if (deviceMode.value != "desktop") {
                    closeBottomOverlay();
                  }
                  $("#toast").delay(100).fadeOut();
                  if (_proceed) {
                    setTimeout(() => {
                      router.push("/booking");
                    }, 200);
                  }
                }
              });
            }
          }).catch(function (err) {
              eventBus.emit("showToast", { msg: "Ops! Error"+err, warning: true });
              console.log(err);
                store.dispatch("cart/updateItem", {
                  cartId: 0,
                  token: null,
                });              
            });
        }
      } else {
        if (deviceMode.value == "desktop") {
          const anchor = document.getElementById("bookingAnchor");
          setTimeout(() => {
            anchor.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }, 50);
        }
        eventBus.emit("showToast", {
          msg: product.value.useDateCompulsory
            ? "請選擇數量及使用日期！"
            : "請選擇數量！",
          warning: true,
        });
      }
    };

    const resetChildSelected = (parentId) => {
        inputList.value.forEach(function (item) {
            if(item.dependQuestionKey==parentId){
                item.infoInputOptions.forEach(function (option) {
                   option.selected=false;
                  }); 
                resetChildSelected(item.questionKey);
            }
        });
   }
    
    const addCarRentalToCart = async (_proceed) => {
      if (pickupBranch.value == "未選擇" || returnBranch.value == "未選擇") {
        if (deviceMode.value == "desktop") {
          const anchor = document.getElementById("bookingAnchor");
          setTimeout(() => {
            anchor.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }, 50);
        }
        eventBus.emit("showToast", {
          msg: "請完成租車選項！",
          warning: true,
        });
      } else {
        eventBus.emit("showToast", {
          msg: "請稍候，系統處理中...！",
          warning: false,
        });
        carRentalItems.value = [];
        carRentalOptionIds.value = [];
        carOptions.value.forEach(function (e) {
          carRentalOptionIds.value.push(e.id);
        });
        carRentalOptionIds.value.sort();
        carRentalItems.value.push({
          productId: product.value.productId,
          carId: carId.value,
          rateType: rateType.value,
          pickupBranchId: pickupBranchId.value,
          returnBranchId: returnBranchId.value,
          pickupDate: product.value.pickupDate,
          pickupTime: product.value.pickupTime,
          returnDate: product.value.returnDate,
          returnTime: product.value.returnTime,
          carRentalOptionIds: carRentalOptionIds.value,
        });
        console.log(carRentalItems.value);
        if (cartItem.value.cartId == 0) {
          const res = await CartApiService.getCartId(member.value.memberId);
          if (res.cartId != undefined && res.token != undefined) {
            await store.dispatch("cart/updateItem", {
              cartId: res.cartId,
              token: res.token,
            });
          }
        }
        const params = {
          proceed: _proceed,
          carRentalItems: carRentalItems.value,
        };
        CartApiService.addItemToCart(
          cartItem.value.cartId,
          cartItem.value.token,
          params
        ).then((res) => {
          console.log(res);
          if (res.state != undefined && res.state == "SUCCESS") {
            CartApiService.getItemCount(cartItem.value.cartId).then((res) => {
              console.log(res);
              if (res.itemCount != undefined) {
                store.dispatch("cart/updateItem", {
                  counts: res.itemCount,
                });
                eventBus.emit("hasAddedToCart");
                if (deviceMode.value != "desktop") {
                  closeBottomOverlay();
                }
                $("#toast").delay(100).fadeOut();
                if (_proceed) {
                  setTimeout(() => {
                    router.push("/booking");
                  }, 200);
                }
              }
            });
          }
        }).catch(function (err) {
            eventBus.emit("showToast", { msg: "Ops! Error"+err, warning: true });
            console.log(err);
              store.dispatch("cart/updateItem", {
                cartId: 0,
                token: null,
              });              
          });
      }
    };

    onBeforeMount(() => {
      eventBus.emit("showSearchIcon", true);
      eventBus.emit("hideSearchBar");
      if (props.category != "car_rental")
        store.dispatch("history/setProducts", props.code);
    });

    onMounted(() => {
      if (props.category == "car_rental") {
        if (props.code.indexOf("|") != -1) {
          splitCode.value = props.code.split("|");
        }
      }
      eventBus.on("selectDateEvent", (obj) => {
        orderList.value.forEach(function (item) {
          if (item.id == obj.productId) {
            item.date = obj.useDate;
            item.price = obj.price;
            item.itemId = obj.itemId;
          }
        });
      });

      
      eventBus.on("selectAPIValue", (argv) => {
    	  console.log("selectAPIValue");
          console.log(argv);
          console.log(orderList);
    	  inputList.value[argv.id].infoInputOptions = undefined;           
          if(argv.val==""){
          }else{
        	  inputList.value[argv.id].infoInputOptions = []; 
               inputList.value[argv.id].infoInputOptions[0]={itemId:"",dependOptionKey:"0",optionKey:"0", optionValue:argv.val,selected:true};
          }
          console.log(inputList.value);
      });
      eventBus.on("selectValue", (argv) => {
        console.log(argv);
        console.log(orderList);        
        argv.data.infoInputOptions.forEach(function (item) {
            if(item.selected){
                  orderList.value.forEach(function (item) {
                    item['addPrice']=item.optionKey;
                  }); 
            }
        });
        if(inputList.value[argv.id]!=undefined){
        inputList.value[argv.id].infoInputOptions.forEach(function (item) {
          item.selected = false;          
          if (item.optionValue == argv.val) {
              item.selected = true;
              var parentId = item.optionKey;
              for(var i =0;i<inputList.value.length;i++){                  
                  if(i!=argv.id &&
                     inputList.value[argv.id].questionKey== inputList.value[i].dependQuestionKey
                   ){
                      console.log(inputList.value[i]);
                      inputList.value[i]["infoInputOptions"] = inputList.value[i].infoInputOptions_.filter(()=>true);
                      inputList.value[i].infoInputOptions =
                      inputList.value[i].infoInputOptions.filter(function (el){
                          return el.dependOptionKey == parentId
                      });
                  }                  
              }
              if(item.itemId!=0||item.itemId!=null){
                  console.log(item.itemId);
                 eventBus.emit("filterItems", item.itemId.split(','));
                 /*orderList.value.forEach(function (item) {
                	 item.date = placeholder;                     
                     item.qty=0;
                   });*/
              }
              eventBus.emit("resetSelectedValue", argv.data.questionKey);     
          }
        });
        }
      });

      eventBus.on("inputValue", (argv) => {
        console.log(argv);
        inputList.value[argv.id].value = argv.val.trim();
      });

      eventBus.on("addTktProductToCart", (proceed) => {
        addTktProductToCart(proceed);
      });

      eventBus.on("addCarRentalToCart", (proceed) => {
        addCarRentalToCart(proceed);
      });

      eventBus.on("selectedPickupBranch", (_pickupBranch) => {
        pickupBranchId.value = _pickupBranch.id;
        pickupBranch.value = _pickupBranch.name;
      });

      eventBus.on("selectedReturnBranch", (_returnBranch) => {
        returnBranchId.value = _returnBranch.id;
        returnBranch.value = _returnBranch.name;
      });

      eventBus.on("checkedCarOption", (_checkedCarOptions) => {
        carOptions.value = _checkedCarOptions;
      });

      if (props.category == "car_rental" && splitCode.value.length == 9) {
        carId.value = splitCode.value[2];
        rateType.value = splitCode.value[1];
        const params = {
          carSearchCriteria: [
            {
              key: "PICKUP_REGION_ID",
              value: splitCode.value[3],//carRentalForm.value.pickupRegion,
            },            
            {
              key: "PICKUP_DATE",
              value: splitCode.value[4],//carRentalForm.value.pickupDate,
            },
            {
              key: "PICKUP_TIME",
              value: splitCode.value[5],/*`${
                carRentalForm.value.pickupHour == "24"
                  ? "00"
                  : carRentalForm.value.pickupHour
              }:${
                carRentalForm.value.pickupMinute == "60"
                  ? "00"
                  : carRentalForm.value.pickupMinute
              }`,*/
            },
            {
                key: "RETURN_REGION_ID",
                value: splitCode.value[6],//carRentalForm.value.returnRegion,
             },
            {
              key: "RETURN_DATE",
              value: splitCode.value[7],//carRentalForm.value.returnDate,
            },
            {
              key: "RETURN_TIME",
              value: splitCode.value[8],/*`${
                carRentalForm.value.returnHour == "24"
                  ? "00"
                  : carRentalForm.value.returnHour
              }:${
                carRentalForm.value.returnMinute == "60"
                  ? "00"
                  : carRentalForm.value.returnMinute
              }`,*/
            },
            {
              key: "PRODUCT_ID",
              value: splitCode.value[0],
            },
            {
              key: "RATE_TYPE",
              value: splitCode.value[1],
            },
            {
              key: "CAR_MODEL_ID",
              value: splitCode.value[2],
            },
          ],
          pageInfoRequest: {
            pageSize: 1,
            pageNo: 1,
          },
        };
        ApiService.getCarRentalDetail(params).then((res) => {
          console.log(res);
          if (
            res.carProductDetailResponse != undefined &&
            Object.keys(res.carProductDetailResponse).length > 0
          ) {
            product.value = res.carProductDetailResponse;
            isLoading.value = false;
            handleNextTick();
          }
        });
      } else {
        ApiService.getProductDetail(props.code).then((res) => {
          console.log(res);
          if (res.ismProductDetailResponse != undefined) {
            product.value = res.ismProductDetailResponse;
            if (
              product.value.price != undefined &&
              product.value.price.length > 0
            ) {
              product.value.price.forEach(function (item) {
                orderList.value.push({
                  id: item.itemId,
                  itemId: 0,
                  title: product.value.productName,
                  name: item.itemName,
                  date: product.value.useDateCompulsory
                    ? placeholder
                    : "3000-12-31",
                  currency: item.currencyCode,
                  price: item.sellingPrice,
                  qty: 0,
                  min: item.qtyMin==undefined?"0":item.qtyMin,
                  max: item.qtyMax==undefined?"10":item.qtyMax,
                  step: item.qtyStep==undefined?"1":item.qtyStep,
                  isDisplay: true,
                });
              });
            }
            CartApiService.getAdditionalInfoInput(product.value.productId).then(
              (res) => {
                if (res.length > 0) {
                    var hasMultiLayer = false;
                  inputList.value = res;
                  inputList.value.forEach(function (item, index) {
                   if(item.type == "LIST"||item.type=="RADIOBUTTON"||item.type=="CHECKBOX"){
                   item.infoInputOptions.forEach(function(item, index) {
                          hasMultiLayer=  hasMultiLayer|| item.itemid!="";
                          if(hasMultiLayer) return;
                    });
                   }
                    item.id = index;
                    if(item.infoInputOptions!=undefined) item["infoInputOptions_"] = item.infoInputOptions.filter(()=>true);
                    if (item.type == "FREETEXT" && item.value == undefined)
                      item.value = "";
                  });
                  if(hasMultiLayer) {
                  orderList.value.forEach(function (item) {
                      item.isDisplay= false;
                    });
                  }
                }                
                isLoading.value = false;
                handleNextTick();
              }
            );
          }
        });
      }
    });

    onBeforeUnmount(() => {
      closeBottomOverlay();
      eventBus.off("selectDateEvent");
      eventBus.off("selectValue");
      eventBus.off("inputValue");
      eventBus.off("addTktProductToCart");
      eventBus.off("addCarRentalToCart");
      eventBus.off("selectedPickupBranch");
      eventBus.off("selectedReturnBranch");
      eventBus.off("checkedCarOption");
    });

    return {
      isLoading,
      deviceMode,
      product,
      inputList,
      moment,
      msg,
      cartItem,
      orderList,
      placeholder,
      categroyName,
      search,
      pickupBranch,
      returnBranch,
      carOptions,
      openBottomOverlay,
      closeBottomOverlay,
      totalAmount,
      addCarRentalToCart,
      addTktProductToCart,
    };
  },
};
</script>

<style scoped>
.vueperslide,
.vueperslide--active,
.vueperslide--visible {
  background-size: contain !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
  background: #fff;
}
</style>
